module.exports = __webpack_public_path__ + "img/error-floor.be2f975f.png";